import { site } from '@/content/site';

export function Footer() {
  return (
    <footer className="border-t border-rule mt-20">
      <div className="max-w-page mx-auto px-[var(--space-gutter)] py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="label">{site.copyright}</div>
        <ul className="flex gap-5">
          {site.links.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
                className="label no-underline hover:text-accent transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
